import React from 'react';
import { CheckIcon } from 'lucide-react';
import { serviceColumns } from '../data/site';
import { Reveal } from './Reveal';
import { GlassWhatsApp } from './ContactButtons';
export function Services() {
  return <section id="servicios" className="relative w-full bg-ink py-16 sm:py-24" data-id="element-128" data-mp="1dszlg47dl7pk">
      <div className="mx-auto max-w-7xl px-5" data-id="element-129" data-mp="18vh9e4y2acdc">
        <div className="max-w-2xl" data-id="element-130" data-mp="18uoblth2yx7c">
          <Reveal data-id="element-131" data-mp="13vuzo5hfze9a">
            <p className="font-sans text-xs font-medium uppercase tracking-[0.35em] text-white/40" data-id="element-132" data-mp="13w4ohpqr3fde">
              Trabajos y servicios
            </p>
          </Reveal>
          <Reveal delay={0.08} data-id="element-133" data-mp="u61lqxttun1v">
            <h2 className="mt-5 font-serif text-4xl leading-tight text-white sm:text-5xl" data-id="element-134" data-mp="u5a30nlbwjt0">
              Cada caso recibe un <span className="text-gold-light" data-id="element-135" data-mp="q5hozvd61lg9">ritual propio</span>.
            </h2>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-8 lg:grid-cols-2 lg:gap-10" data-id="element-136" data-mp="l4u1hjo5bmqs">
          {serviceColumns.map((column, i) => <Reveal key={column.title} delay={i * 0.12} data-id="element-137" data-mp="g8dbejxdyyb2" data-mpi={i}>
              <article className="flex h-full flex-col overflow-hidden rounded-[1.75rem] border border-white/10 bg-white/[0.03] shadow-[0_40px_100px_-45px_rgba(0,0,0,0.95)] transition-transform duration-300 ease-smooth hover:-translate-y-1" data-id="element-138" data-mp="36betc0n2vhjr">
                <div className="relative h-60 overflow-hidden sm:h-72" data-id="element-139" data-mp="2x9otc6f4raad">
                  <img src={column.image} alt={column.imageAlt} className="h-full w-full object-cover" data-id="element-140" data-mp="32be3ljuj3jxe" />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/30 to-transparent" data-id="element-141" data-mp="3q0ynq62f4n89" />
                  <div className="absolute inset-x-0 bottom-0 p-6" data-id="element-142" data-mp="3u193ubjxcu0u">
                    <p className="font-sans text-[11px] font-medium uppercase tracking-[0.3em] text-gold-light/80" data-id="element-143" data-mp="3g17u06lomc98">
                      {column.kicker}
                    </p>
                    <h3 className="mt-2 font-serif text-3xl leading-tight text-white sm:text-4xl" data-id="element-144" data-mp="24mkukj6mrs71">
                      {column.title}
                    </h3>
                  </div>
                </div>

                <ul className="flex flex-1 flex-col gap-4 p-7" data-id="element-145" data-mp="1pkcbhzn232jq">
                  {column.items.map(item => <li key={item} className="flex items-start gap-3" data-id="element-146" data-mp="1ljk296e6oxng">
                      <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold-light/15 ring-1 ring-gold-light/40" data-id="element-147" data-mp="1griqrmoubayh">
                        <CheckIcon className="h-3 w-3 text-gold-light" aria-hidden="true" data-id="element-148" data-mp="1bsfo28wc1gto" />
                      </span>
                      <span className="font-sans text-[15px] leading-relaxed text-white/75" data-id="element-149" data-mp="16r8h2c20klo2">{item}</span>
                    </li>)}
                </ul>

                <div className="mt-auto flex justify-center border-t border-white/10 p-6 sm:justify-start" data-id="element-150" data-mp="xtg7zpmvya94">
                  <GlassWhatsApp size="md" data-id="element-151" data-mp="svo6c3wfv9rq">Consultar este trabajo</GlassWhatsApp>
                </div>
              </article>
            </Reveal>)}
        </div>
      </div>
    </section>;
}